import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-unidades',
  templateUrl: './landing-unidades.component.html',
  styleUrls: ['./landing-unidades.component.scss']
})
export class LandingUnidadesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
